export enum EditOptionType {
  TRANSFORM = 'resize',
  CROP = 'crop',
  OPTIMIZE = 'optimize',
  TRIM = 'trim',
}

export default EditOptionType;
